import script from "./LessonsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonsTab.vue?vue&type=script&setup=true&lang=js"

import "./LessonsTab.vue?vue&type=style&index=0&id=78f6f14f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78f6f14f"]])

export default __exports__